import UserActions from './actions';

const actions = {
  START_WITHDRAW_POLL_SUCCESS: true,
};

const refreshUserData = store => {
  store.dispatch(UserActions.FETCH_USER_METADATA());
};

export default store => next => action => {
  next(action);
  if (actions[action.type]) {
    refreshUserData(store);
  }
};
